export default "__VITE_ASSET__4d6a9ce7__"